export function deleteCookie(cookieName: string, domain?: string) {
  // Browsers can't delete cookies, they can set cookies with past expirations though.
  const expired = new Date();
  expired.setFullYear(expired.getFullYear() - 1);
  if (domain) {
    document.cookie = `${cookieName}=;expires=${expired.toUTCString()};domain=${domain};`;
  } else {
    document.cookie = `${cookieName}=;expires=${expired.toUTCString()}`;
  }
}
